var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-leaf-block-root"},[_c('e-cont',{attrs:{"x":_vm.x,"y":_vm.y,"r":_vm.r,"s":_vm.s}},_vm._l((_vm.poses),function(pos){return _c('tree-leaf',{key:pos.id,attrs:{"r":pos.r,"s":pos.s}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }